'use client';

import { usePathname } from 'next/navigation';
import type { PageType } from '@libs/common-next';

interface Props {
    readonly pageType: PageType;
}

/** Seperate check for confirmation as Confirmatuon is sharing the same layout.tsx with cart.
 * As a result there is no seperate page type for confirmation set from layout.tsx .
 * We are setting that from here based on the confirmation page path name url
 */

const config = {
    '/order-confirmation': 'confirmation',
};
export function PageMeta({ pageType }: Props) {
    const pathname = usePathname() ?? 'n/a';

    return <meta name="page-type" content={config[pathname as keyof typeof config] ?? pageType} />;
}
